import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useState } from 'react'
import {Toast} from '../../common/message';

const BugFiexd = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const location = [
    '선택', '로그인', '회원가입', '메인', '버그 및 개선 요청', '제품판매', '판매내역', '재고관리', '판매량분석', '주문관리', '반출/반입/매입', '고객관리', '택배/퀵', '기타'
  ];
  const question = ['선택', '버그 제보', '개선 요청', '기능 추가', '기타'];

  const [sendLocation, setSendLocation] = useState('');
  const [sendType, setSendType] = useState('');
  const [sendText, setSendText] = useState('');

  // 전송 기능 함수
  const sendData = async (e) => {

    if(!sendLocation) return alert('문제 위치를 선택해주세요');
    if(!sendType) return alert('제보 분류를 선택해 주세요');
    if(!sendText) return alert('제보하실 내용을 입력해 주세요');

    if(!window.confirm('해당 내용들을 전송하시겠습니까?')) return;
    
    await Axios.post(`/api/bugfixed/send`, {
      State: '대기중', Location: sendLocation, Type: sendType, Text: sendText, UserID: window.localStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      reset();
      Toast.fire({ icon: "success", titleText: '전송 성공', text: `해결에 도움을 주셔서 감사합니다` });
    })
    .catch((err)=>{
      reset();
      Toast.fire({ icon: "error", titleText: '전송 실패', text: `관리자에게 문의해 주세요` });
      console.log('오류 내용: ', err);
    });    
  };
  const sendHandler = ()=>{
    sendData();
  }

  // 초기화 함수
  const reset = ()=>{
    setSendLocation('');
    setSendType('');
    setSendText('');
  }

  return (
    <div className='flex flex-col h-full justify-center items-center'>
      <div className='flex flex-col overflow-y-auto h-auto text-sm w-full md:max-w-4xl items-center gap-3'>

        <p className='text-lg mb-5'>🧪 아래 내용을 작성해 주세요</p>

        <div className='bg-[#2E2E2E] px-3 py-5 rounded-md'>
          <p><span className='decoration-2 underline decoration-red-500/90'>모든 버그, 개선 요청, 등등 문의는 해당 페이지로만 접수해 주세요.</span> 요청 사항들은 작성과 동시에 사용자의 오류 로그 및 해상도와 같은 문제의 소지가있는 정보과 함께 전송됩니다. 사용자 마다 컴퓨터 해상도 및 웹 브라우저 프로그램, 버전 등등 오류 원인이 다양하게 존재하므로. 해당 페이지를 통해서만 접수를 해주시기 바랍니다. <span className='underline decoration-yellow-400 decoration-2'>카톡으로 접수는 자제해주세요.</span> 전송된 데이터들은 따로 분석하여 오류를 해결하는데 큰 도움이됩니다, 100% 해결할 수 있다는 보장은 없으며 접수된 내용들은 반영 없이 삭제될 수도 있습니다.</p>
        </div>

        <div className='grid md:grid-cols-2 grid-cols-1 gap-2 w-full'>
          <div className='w-full'>
            <p>해당 위치</p>
            <select className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400 hover:border-gray-500 active:border-gray-600' value={sendLocation} onChange={(e)=>{
              setSendLocation(e.target.value);
            }}>
              {location.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
          <div className='w-full'>
            <p>요청 분류</p>
            <select className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400 hover:border-gray-500 active:border-gray-600' value={sendType} onChange={(e)=>{
              setSendType(e.target.value);
            }}>
              {question.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>              
        </div>

        <div className='w-full'>
          <p>증상 및 내용</p>
          <textarea 
          maxLength={1000}
          placeholder='문제에 대한 위치, 증상, 내용들을 자세하게 적어주시면 해결에 큰 도움이됩니다'
          className={`w-full h-40 mt-1 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 hover:border-gray-500 active:border-gray-600 ${ !sendText && 'italic text-center' }`}
          value={sendText} onChange={(e)=>{
            setSendText(e.target.value);
          }}/>
          <p className='text-gray-400 text-end text-xs italic'>(1000 글자 제한)</p>
        </div>

        <div className='w-full'>
          <button className='border-[1px] outline-none focus:scale-95 border-blue-500/90 active:scale-[0.98] duration-100 rounded-md w-full md:py-4 py-3 bg-[#2E2E2E]' onClick={(e)=>{
            sendHandler(e);
            console.log('위치: ', sendLocation, '분류: ', sendType, '내용: ', sendText);
          }}>
            전송하기
          </button>
        </div>

      </div>
    </div>
  )
}

export default BugFiexd